import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  coverImage: string;
  categoryId: string;
  categoryName: string;
  author: string;
  publishedAt: string;
  viewCount: number;
  isHot?: boolean;
  size?: 'default' | 'large' | 'small';
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  coverImage,
  categoryName,
  author,
  publishedAt,
  viewCount,
  isHot,
  size = 'default',
}: ArticleCardProps) {
  const isLarge = size === 'large';
  const isSmall = size === 'small';

  return (
    <Link
      to={`/article/${id}`}
      className={`group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer ${
        isLarge ? '' : ''
      }`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[16/7]' : isSmall ? 'aspect-[4/3]' : 'aspect-[16/9]'}`}>
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
        {isHot && (
          <span className="absolute top-3 left-3 bg-accent-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
            热门
          </span>
        )}
        <span className="absolute top-3 right-3 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
          {categoryName}
        </span>
      </div>

      <div className={`${isLarge ? 'p-5 md:p-6' : 'p-4 md:p-5'}`}>
        <h3
          className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 ${
            isLarge ? 'text-lg md:text-xl line-clamp-2' : isSmall ? 'text-sm line-clamp-2' : 'text-base line-clamp-2'
          }`}
        >
          {title}
        </h3>

        {!isSmall && (
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
        )}

        <div className={`flex items-center gap-3 text-xs text-foreground-500 flex-wrap ${isSmall ? 'mt-2' : 'mt-3'}`}>
          <span>{author}</span>
          <span className="text-foreground-300">·</span>
          <span>{publishedAt}</span>
          <span className="text-foreground-300">·</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {viewCount >= 10000 ? `${(viewCount / 10000).toFixed(1)}万` : viewCount}
          </span>
        </div>
      </div>
    </Link>
  );
}